module.exports = __webpack_public_path__ + "img/20-1.0892c8df.png";